import { FeatureFlag } from "../../feature-flags";
import type { Announcement } from "../types";

/**
 * All announcements, ordered newest first.
 *
 * To publish a new announcement:
 * 1. Add a new `Announcement` object at the top of the array (unique `id`)
 * 2. Deploy — users will see a banner for the most recent active announcement
 * 3. After `expiryDays` the banner auto-hides for that announcement
 * 4. Past announcements remain visible on the Release Announcements page
 *
 * To restrict an announcement to users with a feature flag enabled,
 * add a `featureFlag` property referencing a `FeatureFlag` config.
 */
export const announcements: Announcement[] = [
  {
    id: "2026-03-mcp-key-configuration",
    title: "MCP Server Key Configuration",
    body: "You can now configure secure access keys for the Payroll Assistant MCP (Model Context Protocol) server. This lets you securely connect the Payroll Assistant to your favourite AI agents — unlocking richer, more contextual responses tailored to your workflows.\n\nHead to your [settings page](/settings) to add and manage your MCP server keys.",
    releaseDate: "2026-03-25",
    expiryDays: 60,
    featureFlag: FeatureFlag.EnableMcpKeysInterface,
  },
  {
    id: "2026-03-public-knowledge-bases",
    title: "Explore Public Knowledge Bases",
    body: "You can now browse the content of the public knowledge bases powering the Payroll Assistant — including our legislation knowledgebase, which is integrated directly with [the new legislation.govt.nz API](https://legislation.govt.nz/learn-more/news/welcome-to-the-new-nz-legislation-website/). \n\n See exactly what sources inform the Payroll Assistant's answers.  Visit any [public organisation's knowledge base](/org) to explore the documents and sources available.",
    releaseDate: "2026-03-25",
    expiryDays: 60,
  },
  {
    id: "2026-03-legislation-integration",
    title: "Live Legislation Integration",
    body: "The Payroll Assistant's legislation knowledgebase is now integrated directly with [the new legislation.govt.nz API](https://legislation.govt.nz/learn-more/news/welcome-to-the-new-nz-legislation-website/) which was launched on 6 March. This means the payroll legislation knowledge behind your assistant is always up-to-date with the latest authoritative legislation updates — no more waiting for manual refreshes.\n\nWhenever legislation is published or amended on legislation.govt.nz, our knowledgebase automatically reflects those changes, so you can be confident the answers you receive are based on current law.",
    releaseDate: "2026-03-20",
    expiryDays: 60,
  },
];
